export const habaUser = {
  habaCommonUserInformation: {
    nameAndJob: '{{firstName}} {{lastName}}, {{job}}',
    profileImageAlt: 'Profilbild des Benutzers',
    validation: {
      invalidName:
        'Bitte überprüfe, ob dein eingegebener Name keine Zahlen oder untypische Symbole (%&$...) enthält.',
    },
    underConstruction: {
      headline: '“Mein Kundenkonto” ist bald wieder verfügbar!',
      subHeadline:
        'Aufgrund einer Systemanpassung steht diese Funktion derzeit leider nicht zur Verfügung.',
      list1: 'Die Daten in deinem bereits vorhandenen Kundenkonto gehen nicht verloren',
      list2:
        'Du kannst dich gerne zum Newsletter anmelden, um sofort über Neuigkeiten informiert zu werden',
      list3: 'Oder entdecke hier',
      linkText: 'unsere Neuheiten',
      buttonText: 'Zum Newsletter anmelden',
    },
  },
  habaLoginForm: {
    heading: 'Willkommen zurück',
    forgotPassword: 'Passwort vergessen?',
    signIn: 'Anmelden',
    register: 'Jetzt registrieren',
    dontHaveAccount: 'Noch kein Kundenkonto?',
    emailAddress: {
      label: 'E-Mail Adresse',
      wrongEmailFormat: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    },
    password: {
      label: 'Passwort',
      passwordRequired: 'Bitte geben Sie ein Passwort ein.',
    },
    guestCheckout: 'Als Gast bestellen',
    successfulLogin: 'Willkommen! Login erfolgreich',
    accountCannotBeUsed:
      'Sie können sich mit diesem Konto nicht anmelden. Versuchen Sie es mit einer anderen E-Mail-Adresse.',
    reminderEmail: {
      title: 'E-Mail noch nicht bestätigt!',
      description:
        '<strong>Sie haben Ihre E-Mail-Adresse noch nicht bestätigt. Um sich bei uns anzumelden,</strong> Bitte bestätige deine E-Mail-Adresse, dann können wir dein Kundenkonto anlegen. Wir haben dir eine E-Mail geschickt. Klicke einfach auf den Bestätigungs-Link in der E-Mail.<br/><br/>Wenn Sie keine E-Mail erhalten haben, überprüfen Sie bitte Ihren Spam-Ordner oder fordern Sie eine neue E-Mail an.',
      resendEmail: 'E-Mail erneut senden',
      infoTitle: 'Hinweis:',
      infoText:
        'Beachten Sie, dass der Link in der erhaltenen E-Mail <strong>nur 2 Stunden lang</strong> verfügbar ist.<br/><br/>Wenn Sie Ihre E-Mail-Adresse nicht bestätigen, wird <strong>Ihr Konto in 2 Wochen</strong> ab dem Zeitpunkt der Kontoregistrierung gelöscht. Vergessen Sie also nicht, auf den Bestätigungslink zu klicken.<br/><br/><strong>3 Tage</strong> vor der Löschung des <strong>Kontos erhalten</strong> Sie eine Erinnerungs-E-Mail mit einem Link, über den Sie eine neue Bestätigungs-E-Mail anfordern können.',
      activationLinkSent: 'Aktivierungs-E-Mail wurde erfolgreich gesendet.',
      activationLinkError:
        'Beim Senden der Aktivierungs-E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
    },
  },
  habaRegisterForm: {
    registrationInfoHeadline: 'Mit einem Kundenkonto genießen Sie folgende Vorteile: ',
    iconListFirstItemText: 'Einfach Wiederbestellen',
    iconListSecondItemText: 'Transparente Nachverfolgung der Zustellung',
    iconListThirdItemText: 'Einfaches Retournieren',
    heading: 'Neues Kundenkonto anlegen',
    register: 'Jetzt Registrieren',
    registerAsGuest: 'Weiter als Gastkunde',
    emailAddress: {
      label: 'E-Mail Adresse',
      wrongEmailFormat: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    },
    password: {
      label: 'Passwort',
      labelText:
        'Damit deine Logindaten besonders sicher bleiben, kannst Du dein Passwort jederzeit ändern.',
      passwordRequired:
        'Mindestens 6 Zeichen, mindestens ein Sonderzeichen, mindestens einen Großbuchstaben, mindestens einen Kleinbuchstaben, mindestens eine Zahl',
      passwordForbiddenCharsAndTooShort: 'Mindestens 6 Zeichen',
      passwordNoSpecialChars: 'Mindestens ein Sonderzeichen',
      passwordNoUpperCase: 'Mindestens einen Großbuchstaben',
      passwordNoLowerCase: 'Mindestens einen Kleinbuchstaben',
      passwordNoDigits: 'Mindestens eine Zahl',
    },
    passwordRepeat: {
      label: 'Passwort wiederholen',
      passwordRequired: 'Passwort und Passwortwiederholung stimmen nicht überein.',
    },
    postRegisterMessage:
      'Bitte bestätige deine E-Mail-Adresse, dann können wir dein Kundenkonto anlegen.<br/>Wir haben dir eine E-Mail geschickt. Klicke einfach auf den Bestätigungs-Link in der E-Mail.',
    firstName: {
      label: 'Vorname',
      required: 'Pflichtfeld',
    },
    lastName: {
      label: 'Nachname',
      required: 'Pflichtfeld',
    },
    newsletter: 'Zum {{shop}} Newsletter anmelden',
    pendingPage: {
      headline: 'Vielen Dank für die Anmeldeanfrage.',
      subline:
        'Sie erhalten nun eine E-Mail mit einem Bestätigungslink. Bitte überprüfen Sie Ihr E-Mail-Postfach.',
      infoBlock: 'Das Konto wird erstellt, nachdem Sie auf den Bestätigungslink geklickt haben.',
      linkText: 'Zurück zur Startseite',
    },
    privacy: {
      label: 'Ich stimme den <a>Datenschutzbestimmungen</a> zu.',
      required: 'Bitte bestätige, dass du unsere Datenschutzerklärung gelesen und akzeptiert hast.',
    },
    checkoutRegister: {
      headline: 'Als Neu- / Gastkunde bestellen',
      orderAsGuestTitle: 'Als Gast bestellen?',
      orderAsGuestText: 'Ja, ich möchte als Gast bestellen',
    },
  },
  habaNavLogin: {
    login: 'Anmelden',
    register: 'Registrieren',
    logoutLink: 'Abmelden',
    logout: 'Nicht {{name}}?',
    successfulLogout: 'Logout erfolgreich.',
    loginIncentiveText:
      'Melde Dich mit deinem Kundenkonto an und profitiere von den Family Club-Angeboten.',
    loginIncentiveTextHaba:
      'Melde dich mit deinem Kundenkonto an und profitiere von Schnellbestellungen und Rabatten.',
    modal: {
      headline: 'Mein Account',
      myProfile: 'Mein Profil',
    },
    myAccount: {
      overview: 'Übersicht',
      orders: 'Bestellungen',
      accountData: 'Kundendaten',
      deliveryAddresses: 'Lieferadressen',
    },
  },
  habaForgottenPassword: {
    heading: {
      forgotPassword: 'Passwort vergessen? <br/> Kein Problem!',
      resetMailSend: 'Passwort zurücksetzen',
      resetPassword: 'Neues Passwort vergeben',
    },
    infoText: {
      forgotPassword:
        'Bitte nutze die E-Mail Adresse, die du zur Registrierung deines Konto´s verwendet hast. <br/> Wir senden dir dann einen Link, den du verwenden kannst um ein neues Passwort zu vergeben.',
      resetMailSend: {
        firstPart: 'Wir haben dir eine E-Mail an <b>{{ emailAddress }}</b> gesendet.',
        secondPart: 'Bitte folge dem Link in der E-Mail um ein neues Passwort zu vergeben.',
      },
      noEmailInfo: {
        headline: 'Keine Nachricht erhalten?',
        reason1: 'Überprüfe ob die E-Mail-Adresse korrekt ist',
        reason2: 'Überprüfe deinen Spam Ordner',
        newUser: 'Du bist neu bei HABA? Dann erstelle ',
        newUserLinkText: 'hier',
        yourAccount: ' dein Kundenkonto',
        backToAccount: 'Zurück zur Anmeldung',
      },
      resetPassword:
        'Damit dein Konto auch weiterhin sicher bleibt, muss dein Passwort mindestens die folgenden Zeichen beinhalten:',
    },
    emailAddress: {
      label: 'E-Mail Adresse',
      wrongEmailFormat: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    },
    button: {
      submitResetPassword: 'Passwort zurücksetzen',
      backToLogin: 'Zurück zur Anmeldung',
      submitNewPassword: 'Neues Passwort vergeben',
    },
    errorMessage:
      'Aufgrund von technischen Problemen konnte der Passwort-Zurücksetzen-Prozess nicht ausgeführt werden. Versuchen Sie es später noch einmal...',
    tokenExpired:
      'Ihr Token ist abgelaufen. Bitte fordern Sie eine neue Passwort-Vergessen E-Mail an.',
    passwordChangeSuccess: {
      heading: 'Neues Passwort erfolgreich vergeben.',
      message: 'Melde dich jetzt mit deinem neuen Passwort an.',
      button: 'ZUR ANMELDUNG',
    },
  },
  habaProRegisterForm: {
    button: {
      submit: 'Jetzt registrieren',
    },
    form: {
      additionalAddressInfo: 'Adresszusatz',
      company: 'Firma',
      contactPerson: 'Ansprechpartner',
      country: 'Land',
      firstName: 'Vorname',
      gtc: 'Ich erkenne die Datenschutzerklärung sowie die AGB an. Sie haben per Gesetz ein 14-tägiges Widerrufsrecht. Einzelheiten und Ausnahmen dazu in unserer Widerrufsbelehrung.',
      industry: 'Branche',
      institution: 'Institution',
      lastName: 'Nachname',
      madam: 'Frau',
      optional: '(optional)',
      phone: 'Telefonnummer',
      sir: 'Herr',
      street: 'Straße',
      streetNumber: 'Hausnummer',
      town: 'Stadt',
      zip: 'Postleitzahl',
    },
    formError: {
      gtc: 'Bitte die AGB akzeptieren.',
      phoneNumberFormat: 'Bitte im Format: +4912345678',
      zipCodeLength: 'Die Postleitzahl muss {{length}} Stellen lang sein.',
    },
    messages: {
      registeredSuccessfully: 'Erfolgreich registriert.',
      userAlreadyExists: 'Nutzer existiert bereits.',
    },
  },
  habaAccountOverview: {
    personalProfile: 'Persönliches Profil',
    personalProfileMessage:
      'Dies ist dein persönliches {{storeName}} Profil, hier findest du alle wichtigen Informationen und jede Menge Inspirationen!',
    pageTitle: 'Willkommen in ihrem Kundenkonto',
    pageDescription: 'lorem ipsum set delor',
    card: {
      orders: {
        title: 'Meine Bestellungen',
        text: '',
        btnText: 'Zur Bestellübersicht',
      },
      wishlist: {
        title: 'Meine Merkzettel',
        text: '',
        btnText: 'Zum Merkzettel',
      },
      customerData: {
        title: 'Meine Kundendaten',
        text: '',
        btnText: 'Zu meinen Daten',
      },
      delivery: {
        title: 'Meine Lieferadressen',
        text: '',
        btnText: 'Zu den Lieferadressen',
      },
    },
  },
  habaCustomerData: {
    loginData: {
      changeEmailAndSave: 'E-Mail Adresse ändern & speichern',
      changeLoginData: 'Logindaten ändern',
      changePasswordAndSave: 'Passwort ändern & speichern',
      confirmNewEmail: 'Neue E-Mail Adresse bestätigen',
      confirmNewPassword: 'Neues Passwort bestätigen',
      currentEmail: 'Aktuelle E-Mail Adresse',
      currentPassword: 'Aktuelles Passwort',
      currentPasswordRequired: 'Bitte geben Sie Ihr aktuelles Passwort ein.',
      emailsMustMatch: 'E-Mail Adressen müssen übereinstimmen',
      invalidEmail: 'Bitte geben Sie eine gültige E-Mail Adresse ein',
      newEmail: 'Neue E-Mail Adresse',
      newPassword: 'Neues Passwort',
      emailUpdated: 'E-Mail-Adresse wurde aktualisiert',
      passwordUpdated: 'Passwort wurde aktualisiert',
      changeError: 'Das hat leider nicht geklappt, bitte versuchen Sie es noch einmal',
    },
    deliveryAddress: {
      addDeliveryAddress: 'Lieferadresse hinzufügen',
      defaultDeliveryAddress: 'Standardlieferadresse',
      delete: 'Entfernen',
      deleteDeliveryAddress: 'Lieferadresse entfernen?',
      deliveryAddresses: 'Lieferadressen',
      edit: 'Bearbeiten',
      newDeliveryAddress: 'Eine Lieferadresse hinzufügen',
      pendingOrders:
        'Ausstehende Bestellungen, die an diese Adresse gesendet werden, werden nicht storniert.',
      phoneNumber: 'Tel.-Nr.',
      updateDeliveryAddress: 'Lieferadresse aktualisieren',
    },
    overview: {
      address: 'Anschrift',
      billingAddress: 'Rechnungsadresse',
      emailAddress: 'E-Mail Adresse',
      loginData: 'Login Daten',
      myData: 'Meine Daten',
      name: 'Name',
      noBillingAddress: 'Sie haben noch keine Rechnungsadresse.',
      password: 'Passwort',
      personalData: 'Persönliche Daten',
      phoneNumber: 'Telefonnummer',
    },
    childrenData: {
      createNew: {
        btn: 'Kind hinzufügen',
        heading1: 'Neues Geburtstagskind',
        heading2: 'Warum möchten wir die Mitglieder deiner Familie kennenlernen?',
        desc1:
          'Bisher hast du noch keinen Geburtstag für dein Kind hinzugefügt. <br/>Füge gleich eins hinzu.',
        Privacy:
          'Mit Klick auf "Speichern" erklärst du dich mit der Verarbeitung der Kinderdaten zur Werbezwecken einverstanden. Du kannst der Nutzung deiner Daten jederzeit widersprechen. Gehe hierfür zu "Kinderdaten verwalten" in deinem Kundenkonto und bearbeite/entferne die gewünschten Daten. Weitere Informationen findest du in der <a href="https://www.haba-play.com/de-de/s/datenschutz">Datenschutzerklärung</a>.',
        option1: 'Geburtstagsgeschenk',
        option2: 'Maßgeschneiderte Angebote',
        option3: 'Noch mehr Vorteile',
        optDesc1:
          'Zum Geburtstag deines Kindes exklusiv für Newsletter-Abonnenten. <a href="{{url}}"><u>Hier anmelden.</u></a>',
        optDesc2: 'Individuelle Angebote speziell auf deine Familie zugeschnitten. <br/> <br/>',
        optDesc3:
          'HABA begleitet Familien von der Schwangerschaft über die Geburt bis ins Teenageralter.',
        addressLimit: 'Sie haben das Maximum von 10 Kindern erreicht.',
        addressLimitText:
          'Wenn Sie ein neues Geburtstagskind hinzufügen möchten, müssen Sie einen der hinzugefügten Geburtstage löschen.',
        successMessage: 'Neuer Geburtstag wurde erstellt',
        errorMessage: 'Etwas ist schief gelaufen. Bitte versuchen Sie es noch einmal.',
        birthDateMonthsMessage: 'Noch <b>{{number}} Monate<b/>',
        birthDateMonthMessage: 'Noch <b>{{number}} Monat<b/>',
        birthDateDaysMessage: 'Noch <b>{{number}} Tage<b/>',
        birthDateDayMessage: 'Noch <b>{{number}} Tag<b/>',
        todayIsBirthDay: '<b>Heute<b/>',
        tomorrowIsBirthDay: '<b>Morgen<b/>',
      },
      edit: {
        heading1: '',
        desc1:
          'Gib das Geburtsdatum deines Kindes ein. Wenn Du mehrere Kinder hast, kannst du für jedes einen Geburtstag hinzufügen. <br/>Du kannst bis zu 10 Geburtstage hinzufügen.',
        cardHeading: 'Ist dein Kind bereits geboren?',
        option1: 'Bereits geborenes Kind',
        option2: 'Voraussichtliches Geburtsdatum bei Schwangerschaft',
        gender: 'Geschlecht',
        name: 'Hast du dir schon einen Namen für dein Kind überlegt?',
        unBornNameLabel: 'Hast du dir einen Namen für das zukünftige Kind überlegt?',
        noGenderLabel: 'Ich weiß es noch nicht',
        dob: 'Geburtsdatum',
        dayOfBirth: 'Geburtstag',
        kind: 'Kind ',
        mainSection: 'Meine Kinderdaten',
        boy: 'Junge',
        girl: 'Mädchen',
        divers: 'Divers',
        pregnant: 'Schwanger',
        day: 'Tag',
        month: 'Monat',
        year: 'Jahr',
        pastDateError: 'Das Datum muss in der Vergangenheit liegen.',
        futureDateError: 'Das Datum muss in der Zukunft liegen.',
        successMessage: 'Daten erfolgreich geändert',
      },
      delete: {
        title: 'Geburtstag löschen',
        desc: 'Möchtest du den ausgewählten Geburtstag wirklich löschen?',
        btnText: 'Geburtstag löschen',
        successMessage: 'Geburtsdatum erfolgreich gelöscht',
      },
    },
    myAccountSectionData: {
      standardShippingAddress: 'Dies ist deine <b> Standard-Lieferadresse <b/>',
      standardBillingAddress: 'Dies ist deine <b> Standard-Rechnungsadresse <b/>',
      makeStandardShippingAddress: 'Als <b> Standard-Lieferadresse <b/> festlegen',
      makeStandardBillingAddress: 'Als <b> Standard-Rechnungsadresse <b/> festlegen',
      editNewAddressHeadline: 'Address Bearbeiten',
      editNewAddressSubHeadline:
        'Bitte geben Sie eine Adresse ein, die Sie speichern und an die Sie Ihre Artikel liefern möchten.',
      newAddressHeadline: 'Neue Adresse hinzufügen',
      noAddressHeadline: 'Keine Adresse hinzugefügt',
      noAddressText:
        'Sie haben noch keine Adresse für sich selbst hinzugefügt.<br/>Fügen Sie jetzt eine Adresse hinzu.',
      personalData: 'Wie lauten deine persönlichen Daten?',
      deleteHeadline: 'Adresse löschen',
      disableDeleteBtnText:
        'Diese Adresse kann nicht gelöscht werden, solange sie als Standard-Liefer- und Rechnungsadresse eingestellt ist. Um die Adresse zu löschen muss eine andere Adresse als Standardadresse ausgewählt werden. <br/><br/> Derzeit haben ist nur eine Adresse vorhanden. Füge eine <b>neue Adresse<b /> hinzu, um die Standard-Adresse zu ändern.',
      deleteTextInfo:
        'Möchten Sie die ausgewählte Adresse wirklich löschen?<br/>Einmal gelöscht, wird sie nicht mehr in Ihren Optionen für Liefer- und Rechnungsadressen angezeigt.',
      tooltipBilling:
        'Bei einer Bestellung wird diese Adresse standardmäßig auf dem Rechnungsdokument angezeigt. Die Adresse kann auch während der Bestellung geändert werden.<br /> <br/> Sie haben derzeit nur eine Adresse hinzugefügt. Um die Standard-Rechnungsadresse zu ändern, müssen Sie eine <b>neue Adresse hinzufügen.<b />',
      tooltipShipping:
        'Diese Adresse ist als Haupt Lieferadresse für die Bestellungskontrolle festgelegt. Sie können sie ändern, indem Sie eine andere Ihrer Adressen auswählen.',
      tooltipCountrySelection:
        'Der Versand ist nur innerhalb der gewählten Länderversion des Onlineshops möglich. Das Land kann unten am Seitenende gewechselt werden. <br />Die Lieferadresse kann auch während der Bestellung einfach hinzugefügt oder geändert werden. Als Rechnungsadresse kann jede Adresse verwendet werden – egal in welchem Land.',
      tooltipCancelBtn:
        'Sie können diese Adresse nicht löschen, solange sie als Rechnungsadresse oder Lieferadresse eingestellt ist. Nachdem Sie eine andere Adresse als Ihre Hauptadresse ausgewählt haben, kann diese gelöscht werden.<br /> <br/> Derzeit haben Sie eine Adresse hinzugefügt. Um die Haupt Lieferadresse zu ändern, müssen Sie also eine <b>neue Adresse hinzufügen.<b />',
    },
    invoiceDownload: {
      headline: 'Rechnungsanforderung',
      secondHeadline:
        'Sie haben die Rechnung nicht mehr zur Hand und benötigen eine Rechnungskopie?',
      descriptionPart1:
        'Einfach hier herunterladen. Geben Sie in den nachfolgenden Eingabefeldern Ihre Kundennummer und Ihre Rechnungsnummer ein und klicken Sie auf Herunterladen.',
      descriptionPart2:
        'Aus Datenschutzgründen wird im Hintergrund geprüft, ob Kundennummer und Rechnungsnummer zusammengehören – nur dann ist das Herunterladen möglich.',
      descriptionPart3:
        'Sie können immer nur eine Rechnung herunterladen. Bei mehreren Rechnungen müssen Sie diese Schritte nacheinander ausführen.',
      inputCustomerNr: 'Kundennummer',
      inputInvoiceNr: 'Rechnungsnummer',
      inputCustomerNrError: 'Die Angabe der Kundennummer ist notwendig.',
      inputInvoiceNrError: 'Die Angabe der Rechnungsnummer ist notwendig.',
      submitButton: 'Rechnung herunterladen',
      notFound:
        'Eine Rechnung für die angegebene Kundennummer und Rechnungsnummer konnte nicht gefunden werden.',
    },
  },
  habaOrderHistory: {
    loading: 'Daten werden geladen...',
    empty: {
      noOrder:
        'Bisher hast Du noch keine Bestellungen in unserem Online-Shop aufgegeben. Schau Dich jetzt um und erkunde unsere große Auswahl an Produkten...',
    },
    headline: 'Meine Bestellungen',
    orderItem: {
      headline: {
        prefix: 'Bestellung vom',
      },
      details: {
        orderNumber: 'Auftragsnummer',
        orderValue: 'Gesamtsumme',
        status: 'Status',
      },
      button: 'Bestellung anzeigen',
    },
    detailView: {
      headline: 'Bestellung',
      backLink: 'Meine Bestellungen',
      label: {
        orderDate: 'Bestelldatum',
        shippingMethod: 'Versandart',
        deliveryAddress: 'Lieferadresse',
        paymentAddress: 'Rechnungsadresse',
        paymentMethod: 'Zahlungsart',
        orderTotal: 'Gesamtsumme',
        totalTax: 'enthaltene MwSt. {{percentFormatted}}',
        deliveryCosts: 'Versandkosten',
        discounts: 'enthaltender Rabatt',
        articleValue: 'Warenwert',
        order: 'Deine Bestellung',
        status: 'Status',
        tracking: 'Sendungsverfolgung',
        numberOfShipments: 'Anzahl Sendungen',
        shipmentStatus: 'Sendungsstatus',
        shipments: 'Sendung {{number}} von {{total}}',
        canceledArticles: 'Stornierte Artikel',
        totalGiftCardAmount: 'Gutscheinwert eingelöst',
        downloadInvoice: 'Rechnung Herunterladen',
      },
      entries: {
        quantity: 'Menge: {{quantity}}',
        color: 'Farbe:',
        size: 'Größe:',
      },
      savings: 'Ihre Ersparnisse',
      initialPrice: 'Ursprünglicher Warenwert',
      includedDiscount: 'enthaltener Rabatt',
      voucherRedemption: 'Gutscheineinlösung',
      addedDiscountCodes: 'Rabattcodes hinzugefügt',
    },
  },
  habaPasswordRules: {
    signLength: '6 Zeichen',
    specialChar: 'ein Sonderzeichen',
    charUppercase: 'einen Großbuchstaben',
    charLowercase: 'einen Kleinbuchstaben',
  },
};
